import type { Deliverable } from '@/hooks/useDeliverables';

export function timeAgo(timestamp: string): string {
  const now = new Date();
  const then = new Date(timestamp);
  const diffMs = now.getTime() - then.getTime();
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
  if (diffDays > 0) return `${diffDays}d`;
  if (diffHours > 0) return `${diffHours}h`;
  return 'just now';
}

export function getBallHolder(deliverable: Deliverable): { name: string; role: string } | null {
  switch (deliverable.status) {
    case 'in_progress':
      return deliverable.assigned_to ? { name: deliverable.assigned_to, role: 'working' } : null;
    case 'in_review':
      return deliverable.reviewer
        ? { name: deliverable.reviewer, role: 'reviewing' }
        : deliverable.assigned_to ? { name: deliverable.assigned_to, role: 'reviewing' } : null;
    case 'revision':
      return deliverable.assigned_to ? { name: deliverable.assigned_to, role: 'revising' } : null;
    case 'approved':
      return { name: 'PM', role: 'to deliver' };
    default:
      return null;
  }
}

export function isStale(deliverable: Deliverable, staleDays: number = 3): boolean {
  if (!['in_review', 'revision'].includes(deliverable.status)) return false;
  if (!deliverable.status_changed_at) return false;
  const now = new Date();
  const changed = new Date(deliverable.status_changed_at);
  const diffDays = (now.getTime() - changed.getTime()) / (1000 * 60 * 60 * 24);
  return diffDays >= staleDays;
}

export function isOverdue(deliverable: Deliverable): boolean {
  if (!deliverable.due_date) return false;
  if (deliverable.status === 'delivered' || deliverable.status === 'approved') return false;
  return new Date(deliverable.due_date + 'T00:00:00') < new Date();
}
